<div class="mfacontainer" id="mfacontainer">
    <div class="mfawrapper" id="mfawrapper">
        <img src="../../../assets/images/entireonhire-logo.svg" style="margin: 0px auto; width: 250px;" alt="Entire On Hire Logo">
        <div class="formHintText text-center"> {{ "page.MFASettings.pageTitle" | translate }}</div>
        <mat-horizontal-stepper #stepper [selectedIndex]="selectedStepIndex" animationDuration="0" [linear]="true">
            <ng-template matStepperIcon="edit">
                <mat-icon>done</mat-icon>
            </ng-template>
            <mat-step id="mfa-stepperOne" [completed]="true" [editable]="false">
                <ng-template matStepLabel> {{
                    "page.MFASettings.matStepLabel.step1.label" | translate
                    }}</ng-template>
            </mat-step>
            <mat-step  [completed]="getActiveStepControl()" [editable]="false" id="mfa-stepperTwo" >
                <ng-template matStepLabel>{{
                    "page.MFASettings.matStepLabel.step2.label" | translate
                    }}
                </ng-template>
                <div class="otp-container" id="otp-container">
                    <div [ngSwitch]="activeTab">
                        <div *ngSwitchCase="'EMAIL'" class="emailotp">
                            <div>
                                <input *ngFor="let digit of otpArray; 
                                let i = index" 
                                type="text" 
                                maxlength="1" 
                                class="otp-input"
                                [(ngModel)]="otpValues[i]" 
                                (input)="onInput($event, i)"
                                [ngClass]="invalidOtp==true || expiredOTP==true?'error':''"
                                (keydown.backspace)="onBackspace($event, i)"
                                (paste)="handlePaste($event)"
                                #otpInput />
                            </div>
                            <div class="otp-error" *ngIf="invalidOtp && otpTouched"
                                style="color: #f44336; font-size: 12px; margin-top: 4px;">
                                {{"page.MFASettings.MFAErrors.OTPErr" | translate }}
                            </div>
                            <div class="otp-error" *ngIf="expiredOTP"
                                style="color: #f44336; font-size: 12px; margin-top: 4px;">
                                {{"page.MFASettings.MFAErrors.OTPErrExpired" | translate }}
                            </div>          
                            <div class="message">
                                <span *ngIf="mfaData?.clientMfa?.UserEmailId; else noEmail">
                                    {{ "page.MFASettings.matStepLabel.step2.verificationLabel" | translate }}
                                    <strong>{{ (mfaData?.clientMfa?.UserEmailId ?? '') | maskEmail }}</strong> {{
                                    "page.MFASettings.matStepLabel.step2.continueBtn" | translate }}
                                </span>
                                <ng-template #noEmail>
                                    {{ "page.MFASettings.matStepLabel.step2.EmailMsg" | translate }}
                                </ng-template>
                            </div>
                        </div>
                        <div *ngSwitchCase="'AUTHY'" class="emailotp">
                            <div *ngIf='this.VerifyButtonHide'>
                                <input *ngFor="let digit of otpArray; let i = index" type="text" maxlength="1" class="otp-input"
                                    [(ngModel)]="otpValues[i]" (input)="onInput($event, i)"  [ngClass]="invalidOtp==true || expiredOTP==true?'error':''"
                                    (keydown.backspace)="onBackspace($event, i)" (paste)="handlePaste($event)" #otpInput />
                            </div>
                            <div class="otp-error" *ngIf="invalidOtp && otpTouched"
                                style="color: #f44336; font-size: 12px; margin-top: 4px;">
                                {{"page.MFASettings.MFAErrors.OTPErr" | translate }}
                            </div>
                            <div class="otp-error" *ngIf="expiredOTP"
                                style="color: #f44336; font-size: 12px; margin-top: 4px;">
                                {{"page.MFASettings.MFAErrors.OTPErrExpired" | translate }}
                            </div>
                            <div class="message">
                                <span *ngIf="mfaData?.clientMfa?.UserPhoneNumber; else noMobile">
                                    {{ "page.MFASettings.matStepLabel.step2.verificationLabel" | translate }}
                                    <strong>{{maskedPhoneNumber }}</strong>
                                    {{ "page.MFASettings.matStepLabel.step2.continueBtn" | translate }}
                                </span>
                                <ng-template #noMobile>
                                    {{ "page.MFASettings.matStepLabel.step2.SMSMsg" | translate }}
                                </ng-template>
                            </div>
                        </div>

                        <div *ngSwitchCase="'HINT'">
                            <div class="message">
                                <span *ngIf="mfaData?.clientMfa?.Questions as questions">
                                    <ng-container *ngIf="questions.length > 0; else noSceruityQues">
                                        <form [formGroup]="securityQuestionForm" onsubmit="submitOtp()" class="security-question">
                                        <p class="box-title">{{"page.MFASettings.matStepLabel.step3.MFAKeyAttributes.SecurityQuesLabel" | translate }}</p>
                                        <div class="question-answer">
                                            <p *ngIf="questions">{{questions[0].Question}}</p>
                                        <!-- <mat-form-field>
                                            <mat-label>
                                            {{"page.MFASettings.matStepLabel.step3.MFAKeyAttributes.SecurityQues1" | translate}}
                                            </mat-label>
                                            <mat-select formControlName="question1">
                                            <mat-option [value]="questions[0].Id">
                                                {{questions[0].Question}}
                                            </mat-option>
                                            </mat-select>
                                        </mat-form-field> -->
                                        <mat-form-field floatLabel="never">
                                            <input matInput placeholder="Enter your answer" type="text" formControlName="answer1" />
                                            <mat-error *ngIf="securityQuestionForm.get('answer1')?.hasError('required')">
                                                {{"page.MFASettings.MFAErrors.answerReqerr" | translate }}
                                            </mat-error>
                                            <mat-error
                                        *ngIf="securityQuestionForm.get('answer1')?.hasError('maxlength') && (securityQuestionForm.get('answer1')?.touched || securityQuestionForm.get('answer1')?.dirty)">
                                        {{"page.MFASettings.MFAErrors.answerMaxerr" | translate }}
                                    </mat-error>
                                        </mat-form-field>
                                        </div>
                                        <div class="question-answer">
                                        <!-- <mat-form-field>
                                            <mat-label>
                                            {{"page.MFASettings.matStepLabel.step3.MFAKeyAttributes.SecurityQues2" | translate}}
                                            </mat-label>
                                            <mat-select formControlName="question2" >
                                                <mat-option [value]="questions[1].Id">
                                                {{questions[1].Question}}
                                                </mat-option>
                                            </mat-select>
                                        
                                        </mat-form-field> -->
                                        <p *ngIf="questions">{{questions[1].Question}}</p>
                                        <mat-form-field floatLabel="never">
                                            <input matInput placeholder="Enter your answer" type="text" formControlName="answer2" />
                                            <mat-error *ngIf="securityQuestionForm.get('answer2')?.hasError('required')">
                                                {{"page.MFASettings.MFAErrors.answerReqerr" | translate }}
                                            </mat-error>
                                            <mat-error
                                            *ngIf="securityQuestionForm.get('answer2')?.hasError('maxlength') && (securityQuestionForm.get('answer2')?.touched || securityQuestionForm.get('answer2')?.dirty)">
                                            {{"page.MFASettings.MFAErrors.answerMaxerr" | translate }}
                                        </mat-error>
                                        </mat-form-field>
                                        </div>
                                        
                                    </form>
                                </ng-container>
                                </span>
                                <ng-template #noSceruityQues>
                                    {{ "page.MFASettings.matStepLabel.step2.secruityQuesMsg" | translate }}
                                </ng-template>
                            </div>
                        </div>

                        <div *ngSwitchCase="'APP'" >
                            <div class="FormGroup">
                                <form [formGroup]="downloadAppStep" onsubmit="submitOtp()" id="downloadAppSection">
                                        <div class="qrcodescaner">
                                    <div class="otp-box" >
                                        <input *ngFor="let digit of otpArray; let i = index" type="text" maxlength="1"
                                            class="otp-input" [(ngModel)]="otpValues[i]"  (paste)="handlePaste($event)"
                                             [ngClass]="invalidOtp==true?'error':''"
                                            [ngModelOptions]="{standalone: true}" (input)="onInput($event, i)"
                                            (keydown.backspace)="onBackspace($event, i)" #otpInput />
                                    </div>
                                    <div class="otp-error" *ngIf="invalidOtp && otpTouched"
                                        style="color: #f44336; font-size: 12px; margin-top: 4px;">
                                        {{"page.MFASettings.MFAErrors.OTPErr" | translate }}
                                    </div> 
                                    <div class="message">
                                        {{ 'page.MFASettings.descriptionPara3' | translate }}
                                    </div>
                                    </div>
                            
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="mfafooter" id="mfafooter">
                        <mat-checkbox [(ngModel)]="rememberMe" *ngIf="mfaData && (mfaData.mfaPref!.isPreferenceSet === 1 &&   mfaData.clientMfa!.NextAuthDays > 0) ">
                            {{ "page.MFASettings.rememberMeForDays" | translate:{ days: mfaData.clientMfa!.NextAuthDays } }} 
                        </mat-checkbox>
                        <button type="submit" mat-raised-button color="primary" id="btnaMFALogin" color="primary"
                            name="login-button" id="btnSubmit" [disabled]="!isVerifyButtonEnabled" (click)="submitOtp()" *ngIf='this.VerifyButtonHide'>
                            {{ "page.MFASettings.matStepLabel.step2.verifyButton" |
                            translate }} 
                        </button>
                        <!-- Verification link -->
                        <button mat-button (click)="toggleVerificationTabs()"
                            style="cursor:pointer; color:#3f51b5; text-decoration:underline;">
                            {{ "page.MFASettings.matStepLabel.step2.verificationBtn" | translate }}
                        </button>
                        <!-- Tab Group: Shown on button click -->
                        <div class="options-container" *ngIf="showVerificationTabs" #verificationTabs>
                            <ng-container *ngFor="let opt of optionList">
                                <div class="option"
                                    *ngIf="opt.show()"
                                    (click)="opt.click()">
                                <i class="fa-solid " [ngClass]="opt.icon"></i>    
                                <!-- <img [src]="'../../../../../assets/images/' + opt.icon" /> -->
                                <div>{{ opt.label | translate }}</div>
                                <small>{{ opt.desc | translate }}</small>
                                </div>
                            </ng-container>
                        </div>
                        <!-- <div class="options-container" *ngIf="showVerificationTabs">
                            <div class="option" *ngIf="activeTab !== 'HINT' && activeTab !== 'APP'"  (click)="activeTab = 'EMAIL',showVerificationTabs=false">
                                <img src="../../../../../assets/images/resendCodeImg.jpg" /> 
                                <div>{{"page.MFASettings.matStepLabel.step2.resendCode" | translate }}</div>
                                <small>{{"page.MFASettings.matStepLabel.step2.resendCodeDesc" | translate }}</small>
                            </div>
                            <div class="option" *ngIf="activeTab !== 'AUTHY' " (click)="activeTab = 'AUTHY',showVerificationTabs=false">
                                <img src="../../../../../assets/images/smsVerifyImg.jpg" /> 
                                <div>{{"page.MFASettings.matStepLabel.step2.smsbtn" | translate }}</div>
                                <small>{{
                                    "page.MFASettings.matStepLabel.step2.smsbtnDesc" | translate }}</small></div>
                            <div class="option" *ngIf="this.activeTab !== 'HINT'" (click)="activeTab = 'HINT',showVerificationTabs=false">
                                <img src="../../../../../assets/images/securityQuesImg.jpg" /> 
                                <div>{{"page.MFASettings.matStepLabel.step2.secruityQues" | translate }}</div>
                                <small>{{
                                    "page.MFASettings.matStepLabel.step2.secruityQuesDesc" | translate }}</small></div>
                            <div class="option" *ngIf="activeTab !== 'APP'" (click)="activeTab = 'APP',showVerificationTabs=false" (click)="get2FAQRCode()">
                                <img src="../../../../../assets/images/qr-code.png" /> 
                                <div>{{ "page.MFASettings.matStepLabel.step2.Qrcode" |
                                translate }}</div>
                                <small>{{
                                    "page.MFASettings.matStepLabel.step2.QrcodeDesc" | translate }}</small></div>
                        </div> -->
                    </div>
                </div>
            </mat-step>
            <mat-step *ngIf="mfaData?.mfaPref?.isPreferenceSet === 0" [editable]="false" id="mfa-stepperthree"
                [completed]="false">
                <ng-template matStepLabel>{{
                    "page.MFASettings.matStepLabel.step3.label" | translate
                    }}</ng-template>
            <app-set-preferences  *ngIf="userMfaPreferences" [userMfaPreferences]="userMfaPreferences" [appQRdata]="appQRdata" 
            (preferencesSaved)="getPrefrencesMaster(mfaDataService.jti,sessionService.getToken(mfaDataService.jti))">

            </app-set-preferences>
            </mat-step>
        </mat-horizontal-stepper>
    </div>
</div>